// extracted by mini-css-extract-plugin
export default {"list":"classes_list__w+si4","title":"classes_title__bIuQY","scrollable":"classes_scrollable__cpIXg"};